import React from 'react';
import {
  Box, Card, Grid, Stack, TextField,
} from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import { Controller, useFormContext } from 'react-hook-form';
import { ContactMessageValues } from '../../../types';

const CONFIG = [
  { name: 'name', label: 'Name' },
  { name: 'email', label: 'Email' },
  { name: 'country', label: 'Country' },
  { name: 'city', label: 'City' },
  { name: 'message', label: 'Message', multiline: true },
];

// eslint-disable-next-line max-len
export const ContactMessageForm: React.FC<{ onAction: (values: ContactMessageValues) => Promise<void> }> = ({ onAction }) => {
  const {
    control, handleSubmit, formState: { isSubmitting },
  } = useFormContext();

  return (
    <form onSubmit={handleSubmit(onAction)}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Card sx={{ p: 3 }}>
            <Stack spacing={3}>
              {CONFIG.map(({ name, label, multiline }) => (
                <Controller
                  key={name}
                  name={name as keyof ContactMessageValues}
                  control={control}
                  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      fullWidth
                      label={label}
                      error={!!error}
                      helperText={error?.message}
                      multiline={multiline}
                      minRows={multiline ? 4 : undefined}
                    />
                  )}
                />
              ))}
            </Stack>
            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
              <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                Save Changes
              </LoadingButton>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </form>
  );
};
